import { logEvent } from './logGaEvent'

// On details page, trigger event if user interacts to add a checked bag
export function logCheckedBagsInteraction({ productName }) {
  logEvent('internal_element', {
    link_name: 'checked_bags',
    page_name: 'details',
    product_name: productName,
    type: 'air_bag',
  })
}

// On details page, trigger event if user interacts to add a carry-on bag
export function logCarryOnBagsInteraction({ productName }) {
  logEvent('internal_element', {
    link_name: 'carry-on_bags',
    page_name: 'details',
    product_name: productName,
    type: 'air_bag',
  })
}
